/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailAppMetadata
 */
export interface UserDetailAppMetadata {
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailAppMetadata
     */
    mfa_enrolled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailAppMetadata
     */
    mfa_required?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDetailAppMetadata
     */
    mfa_allowed_methods?: Array<string>;
}

/**
 * Check if a given object implements the UserDetailAppMetadata interface.
 */
export function instanceOfUserDetailAppMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserDetailAppMetadataFromJSON(json: any): UserDetailAppMetadata {
    return UserDetailAppMetadataFromJSONTyped(json, false);
}

export function UserDetailAppMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailAppMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_enrolled': !exists(json, 'mfa_enrolled') ? undefined : json['mfa_enrolled'],
        'mfa_required': !exists(json, 'mfa_required') ? undefined : json['mfa_required'],
        'mfa_allowed_methods': !exists(json, 'mfa_allowed_methods') ? undefined : json['mfa_allowed_methods'],
    };
}

export function UserDetailAppMetadataToJSON(value?: UserDetailAppMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_enrolled': value.mfa_enrolled,
        'mfa_required': value.mfa_required,
        'mfa_allowed_methods': value.mfa_allowed_methods,
    };
}

